import NavigationBanner from "../../components/common/NavigationBanner";
import hand_rise_banner from "../../Assets/Images/hand_rise_banner.png";
import { MdLocationOn, MdCall, MdEmail } from "react-icons/md";
import { contact_details } from "../../Assets/assests";
import { useApp } from "../../context/AppContext";

const ContactInfo = () => {
  const { contact } = useApp();

  // FALLBACKS (existing static values)
  const HEAD_OFFICE = contact?.headOfficeAddress || contact_details.address;
  const PHONE = contact?.phone || contact_details.mobile;
  const EMAIL = contact?.directorEmail || contact_details.email;
  const REGISTERED_OFFICE =
    contact?.registeredOfficeAddress || "Natapada, Jajpur, Odisha 755015";

  const MAP_URL =
    contact?.locationEmbedLink ||
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.5724402337814!2d85.86117279999999!3d20.276559499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a10038e062db%3A0xa69f0807cb5da0f6!2sAFSA!5e0!3m2!1sen!2sin!4v1761390153339!5m2!1sen!2sin";

  return (
    <div className="w-full bg-gray-50 px-4 md:px-[5rem] py-12">
      {/* ---- TOP INFO GRID ---- */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {/* HEAD OFFICE */}
        <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
          <div className="p-4 bg-blue-50 rounded-full">
            <MdLocationOn className="text-3xl text-blue-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800">Head Office</h3>
          <p className="font-normal text-gray-600 text-center leading-relaxed">
            {HEAD_OFFICE}
          </p>
        </div>

        {/* PHONE */}
        <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
          <div className="p-4 bg-green-50 rounded-full">
            <MdCall className="text-3xl text-green-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800">Phone</h3>
          <p className="font-normal text-gray-600 text-center">{PHONE}</p>
        </div>

        {/* EMAIL */}
        <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
          <div className="p-4 bg-red-50 rounded-full">
            <MdEmail className="text-3xl text-red-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800">Email</h3>
          <p className="font-normal text-gray-600 text-center">{EMAIL}</p>
        </div>

        {/* REGISTERED OFFICE */}
        <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
          <div className="p-4 bg-purple-50 rounded-full">
            <MdLocationOn className="text-3xl text-purple-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800">
            Registered Office
          </h3>
          <p className="font-normal text-gray-600 text-center">
            {REGISTERED_OFFICE}
          </p>
        </div>
      </div>

      {/* ---- MAP SECTION ---- */}
      <div className="grid">
        <div className=" bg-white p-2 border rounded-md border-gray-100">
          <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <MdLocationOn className="text-blue-600" />
            Our Location on Map
          </h3>

          <div className="w-full h-96 rounded-lg overflow-hidden">
            <iframe
              title="location"
              src={MAP_URL}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </div>

          <div className="mt-4 flex justify-between items-center">
            <span className="text-sm text-gray-500">{HEAD_OFFICE}</span>

            <a
              href="https://maps.google.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline text-sm"
            >
              View on Google Maps
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Contact = () => {
  return (
    <div>
      <NavigationBanner title={"Contact us"} background={hand_rise_banner} />
      <ContactInfo />
    </div>
  );
};

export default Contact;

// import NavigationBanner from "../../components/common/NavigationBanner";
// import hand_rise_banner from "../../Assets/Images/hand_rise_banner.png";
// import { MdLocationOn, MdCall, MdEmail } from "react-icons/md";
// import { contact_details } from "../../Assets/assests";

// const ContactInfo = () => {
//   return (
//     <div className="w-full bg-gray-50 px-4 md:px-[5rem] py-12">
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//         <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
//           <div className="p-4 bg-blue-50 rounded-full">
//             <MdLocationOn className="text-3xl text-blue-600" />
//           </div>
//           <h3 className="text-lg font-semibold text-gray-800">Head Office</h3>
//           <p className="font-normal text-gray-600 text-center leading-relaxed">
//             {contact_details.address}
//           </p>
//         </div>

//         <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
//           <div className="p-4 bg-green-50 rounded-full">
//             <MdCall className="text-3xl text-green-600" />
//           </div>
//           <h3 className="text-lg font-semibold text-gray-800">Phone</h3>
//           <p className="font-normal text-gray-600 text-center">
//             {contact_details.mobile}{" "}
//           </p>
//         </div>

//         <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
//           <div className="p-4 bg-red-50 rounded-full">
//             <MdEmail className="text-3xl text-red-600" />
//           </div>
//           <h3 className="text-lg font-semibold text-gray-800">Email</h3>
//           <p className="font-normal text-gray-600 text-center">
//             {contact_details.email}{" "}
//           </p>
//         </div>

//         <div className="w-full p-6 flex flex-col items-center gap-4 hover:shadow-md rounded-xl bg-white transition-all duration-300 border border-gray-100">
//           <div className="p-4 bg-purple-50 rounded-full">
//             <MdLocationOn className="text-3xl text-purple-600" />
//           </div>
//           <h3 className="text-lg font-semibold text-gray-800">
//             Registered Office
//           </h3>
//           <p className="font-normal text-gray-600 text-center">
//             Natapada, Jajpur, Odisha 755015
//           </p>
//         </div>
//       </div>

//       <div className="grid">
//         <div className=" bg-white p-2 border rounded-md border-gray-100">
//           <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
//             <MdLocationOn className="text-blue-600" />
//             Our Location on Map
//           </h3>
//           <div className="w-full h-96 rounded-lg overflow-hidden">
//             <iframe
//               title="location"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.5724402337814!2d85.86117279999999!3d20.276559499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a10038e062db%3A0xa69f0807cb5da0f6!2sAFSA!5e0!3m2!1sen!2sin!4v1761390153339!5m2!1sen!2sin"
//               width="100%"
//               height="100%"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               className="rounded-lg"
//             ></iframe>
//           </div>
//           <div className="mt-4 flex justify-between items-center">
//             <span className="text-sm text-gray-500">
//               {contact_details.address}
//             </span>

//             <a
//               href="https://www.google.com/maps/place/Plot+no-686%2F2882,+Shanti+Nagar,+Canal+Road,+Jharpada,+Bhubaneswar,+Odisha+-+751006/@20.2667061,85.8384991,15z/data=!4m6!3m5!1s0x3a190bca6f6f7f7f:0x8e2f3c4f4e5e6d7!8m2!3d20.2667061!4d85.8384991!16s%2Fg%2F11c52_5y5y"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-blue-600 hover:underline text-sm"
//             >
//               {" "}
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Contact = () => {
//   return (
//     <div>
//       <NavigationBanner title={"Contact us"} background={hand_rise_banner} />
//       <ContactInfo />
//     </div>
//   );
// };

// export default Contact;
